import { useContext, useMemo, useEffect } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import { useLocation, useRouteMatch } from 'react-router-dom'
import Swal from 'sweetalert2'
import PNotify from 'pnotify/dist/es/PNotify'
import objectPath from 'object-path'
import { Form, Col, Row } from 'react-bootstrap'
import Label from './Label'
import {
  setApi,
  getServiceRequest,
  getExternalRequest,
  checkConditionNextApi,
  checkConditionApi,
  getApi,
  setHeadersConfig,
  checkPropTab,
} from '../action/Api'
import {
  compareTwoValue,
  getCheckValue,
  getUrlParamValue,
  isNumber,
} from '../action/Data'
import { createDesignerData } from '../action/Design'
import httpClient from 'utility/httpClient.util'
import _ from 'lodash'
import moment from 'moment'
import useAuth from 'hooks/useAuth'
import { onUpdateCondition } from '../action/condition/Action'
import { getFormGroup } from '../action/FormGroup'

const CustomCheckbox = (props) => {
  let {
    value,
    uischema,
    updateCheckbox,
    copyData = () => {},
    errors = {},
    label,
    setIsOnChange,
    fieldName,
    fieldKey,
    data,
  } = props
  let {
    checkboxWidth = '18px',
    checkboxPosition,
    controlId,
    elementWidth,
    checkboxText,
    readonly,
    key,
    require,
  } = uischema || {}

  let valueChecked = getCheckValue(uischema.valueChecked)
  let valueUnchecked = getCheckValue(uischema.valueUnchecked)

  const designContext = useContext(DesignContext)
  const {
    elementAction,
    jsonForm,
    getCurrentUi,
    updateUiSchema,
    setFormData,
    setDesignerPropsData,
    searchData,
    tabParamActive,
    setDatasourceValue,
    widgetDesign,
  } = designContext
  const allFormGroup = getFormGroup(designContext)

  const match = useRouteMatch()
  const location = useLocation()
  const search = location.search || []
  const receivePathParams = match.params
  const urlSearchParams = new URLSearchParams(search)
  const receiveQueryParams = Object.fromEntries([...urlSearchParams])
  const allParams = { ...receivePathParams, ...receiveQueryParams }
  let errorArray = objectPath.get(errors, key) || []
  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', key])
  let isEnable = objectPath.get(elementAction, ['isEnable', key])
  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  let hasRequire = objectPath.has(elementAction, ['isRequire', key])
  let requireMessage = objectPath.get(elementAction, ['isRequire', key])
  let showRequireMessage = hasRequire
    ? typeof requireMessage !== 'boolean'
    : require
  let isRequire = hasRequire || require
  let showRequire = value ? false : isRequire ? true : false

  let hasWarning = objectPath.has(elementAction, ['isWarning', key])
  let warningMessage = objectPath.get(elementAction, ['isWarning', key])
  let showWarningMessage = hasWarning
    ? typeof warningMessage !== 'boolean'
    : warningMessage

  let actionUpdate = objectPath.get(elementAction, ['actionUpdate'])
  let updateOption = objectPath.get(elementAction, ['updateOption'])
  const mapTag = objectPath.get(jsonForm, 'schema.mapTag') || []
  const mapFormData = objectPath.get(jsonForm, 'schema.mapFormData')
  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}
  let formData = objectPath.get(jsonForm, 'formData') || {}
  let action = objectPath.get(uischema, 'action') || {}
  let dataset = objectPath.get(jsonForm, 'dataset') || []
  let datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  const { user } = useAuth()
  let isChecked = compareTwoValue('equalValue', value, valueChecked)

  useEffect(() => {
    if (actionUpdate) {
      actionUpdate.forEach(async (selectKey) => {
        let isUpdateOption = objectPath.get(updateOption, selectKey)
        if (!isUpdateOption) return
        let selectUi = getCurrentUi(selectKey)
        let { optionType } = selectUi
        let optionData = objectPath.get(selectUi, `${optionType}`)
        let { service, endpoint, pathParams, queryParams, url } = optionData

        let api = setApi(
          {
            apiType: optionType,
            service: service,
            endpoint: endpoint,
            pathParams: pathParams,
            queryParams: queryParams,
            jsonForm,
          },
          jsonForm.formData,
        )
        if (optionType === 'internal') {
          if (!service || !endpoint) return
          optionData = await getServiceRequest(api, optionData, selectUi)
        } else if (optionType === 'external') {
          if (!url) return
          optionData = await getExternalRequest(api, optionData, selectUi)
        }
        updateUiSchema(selectUi.key, optionType, optionData)
      })
    }
    onUpdateCondition(props, designContext, uischema.key, data)
  }, [value])

  const styles = {
    left: {
      marginLeft: '0',
      marginRight: 'auto',
    },
    center: {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    right: {
      marginLeft: 'auto',
      marginRight: '0',
    },
  }

  const styleChange = useMemo(() => {
    let style = {
      width: checkboxWidth ? checkboxWidth : '18px',
      height: checkboxWidth ? checkboxWidth : '18px',
    }
    if (checkboxPosition === 'center') {
      style = { ...style, ...styles.center }
    } else if (checkboxPosition === 'right') {
      style = { ...style, ...styles.right }
    } else {
      style = { ...style, ...styles.left }
    }
    return style
  }, [checkboxPosition, checkboxWidth])

  const isFile = (file) => 'File' in window && file instanceof File

  const setRequestFormData = (form, requestBody) => {
    let {
      jsonKey = '',
      mapParam = {},
      mapOther = {},
      mapArray = {},
      isSystem,
      componentName,
    } = form
    let isComponentData = !isSystem
    let paramList = Object.keys(mapParam)
    let dataObj = objectPath(formData)
    paramList.forEach((key) => {
      let name = mapParam[key]
      let dataKey =
        isComponentData && componentName ? `${componentName}.${name}` : name
      let requestKey = jsonKey ? `${jsonKey}.${name}` : name
      let value
      let isArray = objectPath.get(mapArray, key)

      if (isArray) {
        let ui = getCurrentUi(key)
        if (ui.key === key) {
          let arrayData = []
          let { elements = [], param = [] } = ui
          elements.forEach(({ elements = [] }) => {
            let arrayObj = {}
            elements.forEach(({ key, name }) => {
              if (mapFormData[key]) {
                let value = dataObj.get(key)
                objectPath.set(arrayObj, name, value)
              }
            })
            arrayData.push(arrayObj)
          })
          param.forEach(({ tabKey, name, value }) => {
            let index = elements.findIndex((element) => element.key === tabKey)
            if (index > -1) {
              objectPath.set(arrayData, `${index}.${name}`, value)
            }
          })
          objectPath.set(requestBody, requestKey, arrayData)
        }
      } else {
        if (jsonKey) {
          if (dataObj.get(dataKey)) {
            value = dataObj.get(dataKey)
          } else if (dataObj.get(`${key}.${dataKey}`)) {
            value = dataObj.get(`${key}.${dataKey}`)
          } else if (dataObj.get(`${jsonKey}.${dataKey}`)) {
            value = dataObj.get(`${jsonKey}.${dataKey}`)
          }
        } else {
          value = dataObj.has(dataKey) ? dataObj.get(dataKey) : dataObj.get(key)
        }
        if (value === undefined) {
          objectPath.set(requestBody, requestKey, null)
        } else if (value === 'true') {
          objectPath.set(requestBody, requestKey, true)
        } else if (value === 'false') {
          objectPath.set(requestBody, requestKey, false)
        } else if (value === 'null') {
          objectPath.set(requestBody, requestKey, null)
        } else {
          let isTable = objectPath.get(mapTag, [key]) === 'table'
          if (isTable && value) {
            value.map((item) => {
              objectPath.del(item, 'tableData')
              return item
            })
          }
          objectPath.set(requestBody, requestKey, value)
        }
      }
    })
    let otherList = Object.values(mapOther)
    otherList.forEach(
      ({ name, value, dataType = '', jsonKey, tabKey, tabValue = {} }) => {
        let dataKey = jsonKey ? `${jsonKey}.${name}` : name
        if (dataType === 'prop' || dataType === 'system') {
          let value = dataObj.get(dataKey)
          objectPath.set(requestBody, name, value)
        } else if (dataType === 'user') {
          let value = objectPath.get(user, 'userId')
          objectPath.set(requestBody, name, value)
        } else if (dataType === 'urlParam') {
          let urlParamValue = getUrlParamValue(allParams, value, dataKey)
          objectPath.set(requestBody, name, urlParamValue)
        } else if (dataType === 'tab') {
          let [containerKey, paramName] = value.split('.')
          value = checkPropTab({ designContext }, { containerKey, paramName })
          objectPath.set(requestBody, name, value)
        } else if (dataType === 'custom') {
          if (isNumber(value)) {
            objectPath.set(requestBody, name, Number(value))
          } else if (value === 'true') {
            objectPath.set(requestBody, name, true)
          } else if (value === 'false') {
            objectPath.set(requestBody, name, false)
          } else if (value === 'null') {
            objectPath.set(requestBody, name, null)
          } else {
            objectPath.set(requestBody, name, value)
          }
        } else if (dataType === 'dateTime') {
          let now = null
          if (value === 'currentDate') {
            now = moment().format('YYYY-MM-DD')
          } else if (value === 'currentTime') {
            now = moment().format('HH:mm:ss')
          } else if (value === 'currentDateTime') {
            now = moment().format('YYYY-MM-DD HH:mm:ss')
          }
          objectPath.set(requestBody, name, now)
        } else if (dataType === 'datasource') {
          let dataValue = objectPath.get(datasourceValue, value)
          objectPath.set(requestBody, name, dataValue)
        }
      },
    )
    return requestBody
  }

  const setRequestData = (action, formData, files) => {
    let requestData = {}
    let { requestDataType } = action
    let systemData = jsonForm.systemData

    if (requestDataType === 'customData') {
      let { customData = [] } = action
      customData.forEach(
        ({
          request,
          propType,
          value,
          key = '',
          isDynamic = false,
          apiKey,
          dataKey,
        }) => {
          if (isDynamic) {
            value = objectPath.get(formData, request)
          } else if (propType === 'user') {
            value = objectPath.get(user, 'userId')
          } else if (propType === 'input') {
            value =
              objectPath.get(formData, request) || objectPath.get(formData, key)
          } else if (propType === 'system') {
            value = objectPath.get(systemData, key)
          } else if (propType === 'urlParam') {
            value = objectPath.get(allParams, key)
          } else if (propType === 'datasource') {
            value =
              objectPath.get(formData, request) || objectPath.get(formData, key)
          } else if (propType === 'response') {
            let valueKey = dataKey ? `${dataKey}.${key}` : key
            value = objectPath.get(formData, `@response.${apiKey}.${valueKey}`)
          } else if (propType === 'dataset') {
            let foundDataset = dataset.find((data) => data.key === key)
            if (foundDataset) {
              let datasetValue = []
              let { elementKey, elementName, fields } = foundDataset
              let elementData = objectPath.has(formData, elementKey)
                ? objectPath.get(formData, elementKey)
                : objectPath.get(formData, elementName) || []
              elementData.forEach((rowData, index) => {
                fields.forEach(({ field, valueType, value }) => {
                  if (valueType === 'system') {
                    let rowValue = objectPath.get(rowData, field)
                    objectPath.set(datasetValue, `${index}.${field}`, rowValue)
                  } else if (valueType === 'custom') {
                    objectPath.set(datasetValue, `${index}.${field}`, value)
                  }
                })
              })
              value = datasetValue
            } else {
              value = null
            }
          } else if (propType === 'dateTime') {
            let now = null
            if (value === 'currentDate') {
              now = moment().format('YYYY-MM-DD')
            } else if (value === 'currentTime') {
              now = moment().format('HH:mm:ss')
            } else if (value === 'currentDateTime') {
              now = moment().format('YYYY-MM-DD HH:mm:ss')
            }
            value = now
          }
          if (value === undefined) {
            objectPath.set(requestData, request, null)
          } else if (value === 'true') {
            objectPath.set(requestData, request, true)
          } else if (value === 'false') {
            objectPath.set(requestData, request, false)
          } else if (value === 'null') {
            objectPath.set(requestData, request, null)
          } else {
            let isTable = objectPath.get(mapTag, [key]) === 'table'
            if (isTable && value) {
              value.map((item) => {
                objectPath.del(item, 'tableData')
                return item
              })
            }
            objectPath.set(requestData, request, value)
          }
        },
      )
    } else if (requestDataType === 'formData') {
      let formDataList = action?.formDataList
      if (formDataList) {
        formDataList.forEach((item) => {
          let form = allFormGroup.find((form) => form.key === item.key)
          if (!form) return requestData
          let isComponentData = !form.isSystem
          if (isComponentData) {
            requestData = setRequestFormData(item, requestData)
          } else if (form.isGroup) {
            let groupData = form.groupData || []
            groupData.forEach((subGroup) => {
              requestData = setRequestFormData(subGroup, requestData)
            })
          } else {
            requestData = setRequestFormData(form, requestData)
          }
        })
      }
    } else if (requestDataType === 'file') {
      let { fileKey } = action
      if (fileKey) {
        let acceptedFiles = objectPath.get(formData, fileKey)
        const files = new FormData()
        let hasNewFile = false
        for (const file of acceptedFiles) {
          if (isFile(file)) {
            files.append('file', file)
            hasNewFile = true
          }
        }
        requestData = hasNewFile ? files : null
      } else {
        requestData = files
      }
    } else if (requestDataType === 'bulkData') {
      let bulkKey = objectPath.get(action, 'bulkKey')
      let dataKey = objectPath.get(action, 'bulkData.dataKey')
      let key = objectPath.get(action, 'bulkData.key')
      let apiKey = objectPath.get(action, 'bulkData.apiKey')

      let isResponse = objectPath.get(action, 'bulkData.isResponse')
      let bulkRequests = []
      let bulkItems = []
      if (isResponse) {
        let valueKey = dataKey ? `${dataKey}.${key}` : key
        bulkItems = objectPath.get(formData, `@response.${apiKey}.${valueKey}`)
      } else {
        let ui = getCurrentUi(key)
        if (ui.key === key) {
          let isBrowseGallery = ui.galleryType === 'browse'
          if (isBrowseGallery) {
            bulkItems = objectPath.get(formData, `@browseGallery.${key}`)
          } else {
            bulkItems = objectPath.get(formData, key)
          }
        } else {
          bulkItems = objectPath.get(formData, key)
        }
      }
      if (bulkItems) {
        bulkItems.forEach((item) => {
          let bulkRequest = {}
          bulkKey.forEach(
            ({ request, propType, value, key = '', isDynamic = false }) => {
              if (isDynamic) {
                value = objectPath.get(formData, request)
              } else if (propType === 'user') {
                value = objectPath.get(user, 'userId')
              } else if (propType === 'gallery') {
                value = objectPath.get(item, value)
              } else if (propType === 'table') {
                value = objectPath.get(item, key)
              } else if (propType === 'input') {
                value = objectPath.has(formData, key)
                  ? objectPath.get(formData, key)
                  : objectPath.get(formData, request)
              } else if (propType === 'response') {
                value = objectPath.get(item, key)
              } else if (propType === 'system') {
                value = objectPath.get(formData, key)
              } else if (propType === 'urlParam') {
                value = objectPath.get(allParams, key)
              } else if (propType === 'datasource') {
                value = objectPath.get(datasourceValue, value)
              } else if (propType === 'dataset') {
                let foundDataset = dataset.find((data) => data.key === key)
                if (foundDataset) {
                  let datasetValue = []
                  let { elementKey, elementName, fields } = foundDataset
                  let elementData = objectPath.has(formData, elementKey)
                    ? objectPath.get(formData, elementKey)
                    : objectPath.get(formData, elementName) || []
                  elementData.forEach((rowData, index) => {
                    fields.forEach(({ field, valueType, value }) => {
                      if (valueType === 'system') {
                        let rowValue = objectPath.get(rowData, field)
                        objectPath.set(
                          datasetValue,
                          `${index}.${field}`,
                          rowValue,
                        )
                      } else if (valueType === 'custom') {
                        objectPath.set(datasetValue, `${index}.${field}`, value)
                      }
                    })
                  })
                  value = datasetValue
                } else {
                  value = null
                }
              } else if (propType === 'dateTime') {
                let now = null
                if (value === 'currentDate') {
                  now = moment().format('YYYY-MM-DD')
                } else if (value === 'currentTime') {
                  now = moment().format('HH:mm:ss')
                } else if (value === 'currentDateTime') {
                  now = moment().format('YYYY-MM-DD HH:mm:ss')
                }
                value = now
              }
              objectPath.set(bulkRequest, request, value)
            },
          )
          bulkRequests.push(bulkRequest)
        })
      }
      requestData = bulkRequests
    } else if (requestDataType === 'selectRow') {
      let selectRow = objectPath.get(jsonForm, 'componentPropsData.rowData')
      if (!selectRow) return requestData
      let { customData = [] } = action
      customData.forEach(
        ({ request, propType, value, key = '', isDynamic = false }) => {
          if (isDynamic) {
            value = objectPath.get(formData, request)
          } else if (propType === 'table') {
            value = objectPath.get(selectRow, key)
          } else if (propType === 'user') {
            value = objectPath.get(user, 'userId')
          } else if (propType === 'input') {
            value =
              objectPath.get(formData, request) || objectPath.get(formData, key)
          } else if (propType === 'system') {
            value = objectPath.get(formData, key)
          } else if (propType === 'urlParam') {
            value = objectPath.get(allParams, key)
          } else if (propType === 'datasource') {
            value = objectPath.get(datasourceValue, value)
          } else if (propType === 'dataset') {
            let foundDataset = dataset.find((data) => data.key === key)
            if (foundDataset) {
              let datasetValue = []
              let { elementKey, elementName, fields } = foundDataset
              let elementData = objectPath.has(formData, elementKey)
                ? objectPath.get(formData, elementKey)
                : objectPath.get(formData, elementName) || []
              elementData.forEach((rowData, index) => {
                fields.forEach(({ field, valueType, value }) => {
                  if (valueType === 'system') {
                    let rowValue = objectPath.get(rowData, field)
                    objectPath.set(datasetValue, `${index}.${field}`, rowValue)
                  } else if (valueType === 'custom') {
                    objectPath.set(datasetValue, `${index}.${field}`, value)
                  }
                })
              })
              value = datasetValue
            } else {
              value = null
            }
          } else if (propType === 'dateTime') {
            let now = null
            if (value === 'currentDate') {
              now = moment().format('YYYY-MM-DD')
            } else if (value === 'currentTime') {
              now = moment().format('HH:mm:ss')
            } else if (value === 'currentDateTime') {
              now = moment().format('YYYY-MM-DD HH:mm:ss')
            }
            value = now
          }
          if (value === 'true') {
            objectPath.set(requestData, request, true)
          } else if (value === 'false') {
            objectPath.set(requestData, request, false)
          } else if (value === 'null') {
            objectPath.set(requestData, request, null)
          } else {
            let isTable = objectPath.get(mapTag, [key]) === 'table'
            if (isTable && value) {
              value.map((item) => {
                objectPath.del(item, 'tableData')
                return item
              })
            }
            objectPath.set(requestData, request, value)
          }
        },
      )
    }
    console.log('requestData', requestData)
    return requestData
  }

  const getData = async (action, dataGET, formData) => {
    let { responseDataType, customName, dataKey = '', dataTable } = action

    let api = getApi(action, { dataGET, formData, designContext })
    if (!api)
      return {
        status: 500,
        message: 'PUT: no API',
        data: null,
      }

    // set headers config
    let config = setHeadersConfig(action)
    // send request
    let response = await httpClient
      .get(api, config)
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })

    if (response?.status !== 200) {
      let propType = objectPath.get(designerPropsData, `propType`) || {}
      let filterProp = Object.keys(propType)
      filterProp.forEach((key) => {
        let [componentKey, dataKey] = key.split('/')
        if (propType[key] === 'formData') {
          objectPath.set(
            designerPropsData,
            `data.${componentKey}.${dataKey}`,
            {},
          )
        } else {
          objectPath.set(
            designerPropsData,
            `data.${componentKey}.${dataKey}`,
            '',
          )
        }
      })
      return response
    }
    let responseData = objectPath.get(response.data, dataKey)
    objectPath.set(datasourceValue, `${action.key}`, responseData)
    setDatasourceValue(datasourceValue)
    let internalSchema =
      objectPath.get(action, 'internalApi.schema.properties') || {}

    // set form data
    if (responseDataType === 'customData') {
      dataTable.forEach((data) => {
        let value = objectPath.get(responseData, data.response)
        let valueType = internalSchema[data.response]?.type
        if (value === undefined) {
          if (valueType === 'string') {
            value = ''
          } else if (valueType === 'array') {
            value = []
          } else if (valueType === 'object') {
            value = {}
          } else {
            value = null
          }
        }
        if (data.key && data.response) {
          objectPath.set(formData, data.key, value)
        }
        if (data.response) {
          objectPath.set(formData, data.response, value)
        }
      })
      if (customName) {
        objectPath.set(formData, `props.${formData}`, responseData || {})
      }
    } else if (responseDataType === 'formData') {
      dataTable.forEach(
        ({
          response,
          key,
          dynamicName,
          isDynamic,
          isComponentData,
          componentName,
        }) => {
          let value = objectPath.get(responseData, response)
          let valueType = internalSchema[response]?.type
          if (value === undefined) {
            if (valueType === 'string') {
              value = ''
            } else if (valueType === 'array') {
              value = []
            } else if (valueType === 'object') {
              value = {}
            } else {
              value = null
            }
          }
          if (isComponentData && componentName) {
            objectPath.set(formData, `${componentName}.${response}`, value)
          }

          if (isDynamic) {
            objectPath.set(formData, dynamicName, value)
          } else if (key && response) {
            objectPath.set(formData, key, value)
          } else if (response) {
            objectPath.set(formData, response, value)
          }
        },
      )
    }
    return response
  }

  const postData = async (action, dataGET, formData, file) => {
    // set api
    let api = getApi(action, { dataGET, formData, designContext })
    if (!api)
      return {
        status: 500,
        message: 'POST: no API',
        data: null,
      }
    // set request body
    let requestData = setRequestData(action, formData, file)
    let { requestDataType } = action

    if (requestDataType !== 'noRequest') {
      if (
        !requestData ||
        (requestDataType !== 'file' && _.isEmpty(requestData))
      ) {
        return {
          status: 500,
          message: 'POST: request data is empty.',
          data: null,
        }
      }
    }

    // set headers config
    let config = setHeadersConfig(action)
    // send request
    let response = await httpClient
      .post(api, requestData, config)
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })
    return response
  }

  const putData = async (action, dataGET, formData, file) => {
    // set api
    let api = getApi(action, { dataGET, formData, designContext })
    if (!api)
      return {
        status: 500,
        message: 'PUT: no API',
        data: null,
      }
    // set request body
    let requestData = setRequestData(action, formData, file)

    let { requestDataType } = action
    if (requestDataType !== 'noRequest') {
      if (
        !requestData ||
        (action.requestDataType !== 'file' && _.isEmpty(requestData))
      )
        return {
          status: 500,
          message: 'PUT: request data is empty.',
          data: null,
        }
    }
    // set headers config
    let config = setHeadersConfig(action)
    // send request
    let response = await httpClient
      .put(api, requestData, config)
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })

    return response
  }

  const patchData = async (action, dataGET, formData, file) => {
    // set api
    let api = getApi(action, { dataGET, formData, designContext })
    if (!api)
      return {
        status: 500,
        message: 'PUT: no API',
        data: null,
      }
    // set request body
    let requestData = setRequestData(action, formData, file)
    let { requestDataType } = action
    if (requestDataType !== 'noRequest') {
      if (
        !requestData ||
        (action.requestDataType !== 'file' && _.isEmpty(requestData))
      )
        return {
          status: 500,
          message: 'PUT: request data is empty.',
          data: null,
        }
    }
    // set headers config
    let config = setHeadersConfig(action)
    // send request
    let response = await httpClient
      .patch(api, requestData, config)
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })

    return response
  }

  const deleteData = async (action, dataGET, formData) => {
    // set api
    let api = getApi(action, { dataGET, formData, designContext })
    if (!api)
      return {
        status: 500,
        message: 'DELETE: no API',
        data: null,
      }
    // set headers config
    let config = setHeadersConfig(action)
    // send request
    let response = await httpClient
      .delete(api, config)
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })
    return response
  }

  const crud = async (action, formData) => {
    let promiseList = []
    let apiGroup = objectPath.get(action, 'crud.apiGroup') || []
    let filterApi = []
    filterApi = apiGroup.filter((item) => {
      if (item.method === 'get') {
        return checkConditionApi(
          item,
          allParams,
          formData,
          datasourceValue,
          tabParamActive,
        )
      }
      if (item.method === 'post') {
        return checkConditionApi(
          item,
          allParams,
          formData,
          datasourceValue,
          tabParamActive,
        )
      }
      if (item.method === 'put') {
        return checkConditionApi(
          item,
          allParams,
          formData,
          datasourceValue,
          tabParamActive,
        )
      }
      if (item.method === 'patch') {
        return checkConditionApi(
          item,
          allParams,
          formData,
          datasourceValue,
          tabParamActive,
        )
      }
      if (item.method === 'delete') {
        return checkConditionApi(
          item,
          allParams,
          formData,
          datasourceValue,
          tabParamActive,
        )
      }
      return false
    })

    let responseData = formData
    filterApi.map(async (item, index) => {
      let promise = new Promise(async (resolve, reject) => {
        let isNextAPI = index > 0
        let response = {}
        let data = null
        let status = null
        let message = ''
        let awaitPromised = await Promise.all(promiseList)
        awaitPromised.forEach(({ data }) => {
          responseData = { ...responseData, ...(data?.data || {}) }
        })
        if (isNextAPI) {
          let isPass = checkConditionNextApi(item, responseData)
          if (!isPass) {
            return
          }
        }
        if (item.method === 'get') {
          response = await getData(item, {}, formData)
        } else if (item.method === 'post') {
          response = await postData(item, {}, responseData)
        } else if (item.method === 'put') {
          response = await putData(item, {}, responseData)
        } else if (item.method === 'patch') {
          response = await patchData(item, {}, responseData)
        } else if (item.method === 'delete') {
          response = await deleteData(item, {}, formData)
        }

        if (response) {
          data = response.data
          message = response.message
          status = response.status
        }

        if (data) {
          objectPath.set(formData, `@response.${item.key}`, data)
          setFormData(formData)
        }

        if (status >= 400) {
          reject({
            status: status,
            data: null,
            message: message,
            api: item.api,
            apiName: item.apiName,
          })
        } else {
          resolve({
            status: status,
            data: data,
            message: message,
            api: item.api,
            apiName: item.apiName,
          })
        }
      })
        .then((response) => response)
        .catch((error) => error)
      promiseList.push(promise)
    })

    return await Promise.all(promiseList)
  }

  const callApiAction = async () => {
    if (action.name !== 'crud') return
    const promise1 = new Promise(async (resolve, reject) => {
      let response = await crud(action, formData)
      let afterAction = objectPath.get(uischema, 'notification') || {}
      if (Array.isArray(response)) {
        let foundSuccess = response.filter((response = {}) => {
          let { status } = response
          return status >= 200 && status < 300
        })
        if (foundSuccess.length > 0) {
          foundSuccess.forEach((response = {}) => {
            let { data = null } = response
            if (data) {
              formData = { ...formData, ...data }
              setFormData(formData)
            }
          })
          showSuccessNoti(afterAction)
        }
        let foundError = response.filter((response = {}) => {
          let { status } = response
          return status === null || status >= 400
        })
        foundError.forEach((response = {}) => {
          showErrorNoti(afterAction, response)
        })
      } else {
        let { status, data = null } = response || {}
        if (data) {
          formData = { ...formData, ...data }
          setFormData(formData)
        }
        if (status >= 200 && status < 300) {
          showSuccessNoti(afterAction)
        } else {
          showErrorNoti(afterAction, response)
        }
      }
      resolve(formData)
    })

    promise1.then((formData) => {
      designerPropsData = createDesignerData(
        designerPropsData,
        searchData,
        formData,
      )
      setDesignerPropsData(designerPropsData)
    })
  }

  const showSuccessNoti = (afterAction) => {
    if (afterAction.isNotified) {
      let notice = PNotify.success({
        title: afterAction.notifySuccessTitle || 'Success',
        text: afterAction.notifySuccessText,
        icon: 'fas fa-check-circle fa-xl',
      })
      notice.on('click', function () {
        notice.close()
      })
    }
  }

  const showErrorNoti = (afterAction, response) => {
    let { message = '', apiName = '' } = response || {}
    if (afterAction.isNotified) {
      let notice = PNotify.error({
        title: afterAction.notifyErrorTitle || 'Error',
        text: JSON.stringify(message, null, 2) || afterAction.notifyErrorText,
        icon: 'fas fa-exclamation-circle fa-xl',
      })
      notice.on('click', function () {
        notice.close()
      })
      console.error(`Error API Name: ${apiName}`)
    }
  }

  return (
    <Form.Group className="mb-0 mt-1" controlId={controlId}>
      <Row className="w-100 mx-0">
        <Label
          {...props}
          fieldKey={fieldKey}
          fieldName={fieldName}
          uischema={uischema}
          label={label}
          mt={0}
          className={'p-0'}
          isRequire={isRequire}
          isEnable={!checkboxText}
          onClick={() => {
            if (!isReadOnly) {
              updateCheckbox(!isChecked, true)
              copyData(!isChecked)
              callApiAction()
            }
            setIsOnChange(true)
          }}
        />
        <Col
          sm={elementWidth}
          className="p-0 d-flex"
          style={{ alignItems: 'center' }}
        >
          <Form.Control
            style={styleChange}
            type="checkbox"
            id={fieldKey}
            name={fieldName}
            checked={isChecked}
            onChange={(e) => {
              let checked = e.target.checked
              updateCheckbox(checked, true)
              copyData(checked)
              callApiAction()
              setIsOnChange(true)
            }}
            disabled={isReadOnly}
          />
        </Col>
        {checkboxText && (
          <Label
            {...props}
            fieldKey={fieldKey}
            fieldName={fieldName}
            checkboxTextSize="auto"
            style={{ userSelect: 'none' }}
            uischema={uischema}
            label={checkboxText}
            isRequire={isRequire}
            isEnable={!isReadOnly ?? !label}
            onClick={() => {
              if (!isReadOnly) {
                updateCheckbox(!isChecked, true)
                copyData(!isChecked)
                callApiAction()
              }
              setIsOnChange(true)
            }}
          />
        )}
      </Row>
      <ul className="m-0 mt-2">
        {showRequire && showRequireMessage && requireMessage && (
          <li className="text-danger">{requireMessage}</li>
        )}
        {showWarningMessage && warningMessage && (
          <li className="text-danger">{warningMessage}</li>
        )}
        {errorArray.map((error, index) => (
          <li key={`error-${key}-${index + 1}`} className="text-danger">
            {error}
          </li>
        ))}
      </ul>
    </Form.Group>
  )
}

export default CustomCheckbox
